import vInline from "./v-inline.vue";

export default Vue => {
  Vue.component("v-inline", vInline);
};
